import { Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { baseURL, CalendarEvent } from "../../utils/helper";
interface Props {}
function CustomCalendar(props: Props) {
  const {} = props;
  const [value, onChange] = useState(new Date());
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  async function getEvents() {
    try {
      let eventRequest = await fetch(`${baseURL}/getEvents`);
      let eventData: CalendarEvent[] = await eventRequest.json();
      if (eventRequest.ok && eventData?.length > 0) {
        setEvents(eventData);
      } else {
        console.log("Error in getting events");
      }
    } catch (error) {
      console.log("Error in getting events", error);
    }
  }
  const tileContent = ({ date, view }: any) => {
    if (view === "month") {
      const event = events?.find(
        (event) =>
          new Date(event?.event_date)?.toDateString() === date?.toDateString()
      );
      const isDeadline =
        event?.event_title.toLowerCase().includes("deadline") ||
        event?.event_description.toLowerCase().includes("deadline");
      return event ? (
        <Tooltip title={event?.event_description}>
          <Typography
            style={{
              backgroundColor: isDeadline ? "#FF2E2E" : "#007aff",
              fontSize: 10,
              color: "white",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: 50,
            }}
          >
            {event?.event_title}
          </Typography>
        </Tooltip>
      ) : null;
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  return (
    <Calendar
      className="test-calendar"
      onChange={() => {}}
      value={value}
      tileContent={tileContent}
    />
  );
}

export default CustomCalendar;
